import React, { useEffect, useRef, useState } from 'react';
import imageTesta from '../assets/trattamenti/testa-collo.jpg';
import imageSpalle from '../assets/trattamenti/spalla.jpg';
import imageGinocchio from '../assets/trattamenti/ginocchio.jpg';
import imageAnca from '../assets/trattamenti/anca.jpg';
import imagePiede from '../assets/trattamenti/Piede-caviglia.jpg';
import imageSchiena from '../assets/trattamenti/schiena.jpg';
import ContactForm from '../components/contactForm/ContactForm';
import logoShort from "../assets/logo/logo.png";
import { useIntersectionObserver } from '../components/Observer';
import { Helmet } from "react-helmet";
import HumanBody from '../components/3dModel/HumanBody';
import { useNavigate } from 'react-router-dom';
import TecnologieImg from '../assets/tecnologie/the-procedure-of-myo.jpg'
import ContactModal from '../components/ContactModal';
import professionisti from '../assets/trattamenti/fisioterapia.jpg';
import mCareSede from '../assets/azienda/sede-mcare.png';
import player from '../assets/Servizi/player-reversed.jpg';
import section2 from '../assets/Section 2.png';
import logoUniversita from '../assets/logo/logoUniversita.png';
import { FaLocationDot } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import GridBox from '../components/GridBox';
import AnimatedTextWord from '../components/AnimatedTextWord';
import check from '../assets/icon/check.png';
import thunder from '../assets/icon/thunder.png';
import lens from '../assets/icon/lens.png';
import boost from '../assets/icon/boost.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import Hero from '../components/Hero';
import Minimal from '../components/Minimal';


const textsFirstSection = ["Ricerca", "Tempestività", "Performance", "Tecnologia"];
const flags = [
  {
    img: check,
    title: 'VALIDAZIONE ACCADEMICA.',
    subtitle: 'Metodo basato sulle più moderne evidenze scientifiche'
  },
  {
    img: thunder,
    title: 'TEMPESTIVITÀ ASSOLUTA.',
    subtitle: 'Presa in carico e piano d’azione entro 24/48 ore dall’infortunio.'
  },
  {
    img: lens,
    title: 'ANALISI BIOMECCANICA.',
    subtitle: 'Quantifichiamo ogni progresso attraverso dati oggettivi.'
  },
  {
    img: boost,
    title: 'RIENTRO ALLA PERFORMANCE.',
    subtitle: 'Non ci fermiamo alla fine del dolore: ti riportiamo in campo più forte di prima.'
  }
]


function HomePage() {
  const refTesta = useRef(null);
  const refSpalle = useRef(null);
  const refGinocchio = useRef(null);
  const refAnca = useRef(null);
  const refCaviglia = useRef(null);
  const refSchiena = useRef(null);
  const refPaolo = useRef(null);
  const refLuca = useRef(null);
  const refMartin = useRef(null);
  const [contactModal, setContactModal] = useState(false);
  const navigate = useNavigate();

  var ogImage = 'https://mcarefisio.it/static/media/logo2.47585272f37641121cdd.png';

  function goToPage(pageName) {
    navigate(pageName)
  }

  const options = {
    root: null,
    threshold: 0.5,
    rootMargin: "-95px"
  };

  useIntersectionObserver(refTesta, options);
  useIntersectionObserver(refSpalle, options);
  useIntersectionObserver(refGinocchio, options);
  useIntersectionObserver(refAnca, options);
  useIntersectionObserver(refCaviglia, options);
  useIntersectionObserver(refSchiena, options);
  useIntersectionObserver(refPaolo, options);
  useIntersectionObserver(refLuca, options);
  useIntersectionObserver(refMartin, options);

  const handleClickForm = () => {
      const element = document.querySelector('#formContatti');
      element.scrollIntoView({ behavior: 'smooth' });
  };

  // const openContactModal = () => {
  //   setContactModal(true);
  // };

  const closeContactModal = () => {
    setContactModal(false);
  };

  // const [index, setIndex] = React.useState(0);
  // React.useEffect(() => {
  //   const intervalId = setInterval(
  //     () => setIndex((index) => index + 1),
  //     2500,
  //   );
  //   return () => clearTimeout(intervalId);
  // }, []);
  // function animateConsoleLog() {
  //   const styles = [
  //     'font-size: 20px; font-weight: bold; color: #ff007f',
  //     'font-size: 40px; font-weight: bold; color: #ff007f',
  //     'font-size: 60px; font-weight: bold; color: #ff007f',
  //     'font-size: 80px; font-weight: bold; color: #ff007f',
  //     'font-size: 100px; font-weight: bold; color: #ff007f',
  //     'font-size: 80px; font-weight: bold; color: #ff007f',
  //     'font-size: 60px; font-weight: bold; color: #ff007f',
  //     'font-size: 40px; font-weight: bold; color: #ff007f',
  //     'font-size: 20px; font-weight: bold; color: #ff007f'
  //   ];

  //   let index = 0;
  //   const intervalTime = 100;
  //   const duration = 5000;

  //   const intervalId = setInterval(() => {
  //     console.log('%c ciao! ', styles[index]);
  //     index = (index + 1) % styles.length;
  //   }, intervalTime);

  //   setTimeout(() => {
  //     clearInterval(intervalId);
  //   }, duration);
  // }
  

  // flag che si mostrano con hover (sez. università)
  // const [activeFlag, setActiveFlag] = useState(null)
  // const openFlag = (index) => {
  //   setActiveFlag(index);
  // };
  // const closeFlag = () => {
  //   setActiveFlag(null);
  // };


  return (
    <>
      {/* <Helmet>
        <title>Centro di Riabilitazione e Performance a Verona | MCARE</title>
        <meta name="description" content="MCARE è un centro di riabilitazione situato alle porte di Verona. Offriamo trattamenti personalizzati per recupero post-infortunio, post-chirurgico, e gestione del dolore cronico. Prenota una visita oggi stesso!" />
        <meta name="keywords" content="centro di riabilitazione Verona, riabilitazione sportiva, fisioterapia Verona, recupero post-operatorio, trattamento dolore cronico, riabilitazione personalizzata, fisioterapisti esperti, MCARE Verona" />
        <meta property="og:title" content="Centro di Riabilitazione e Performance a Verona | MCARE" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://mcarefisio.it" />
        <meta property="og:image" content={ogImage} />
        <meta property="og:description" content="MCARE è un centro di riabilitazione situato alle porte di Verona. Offriamo trattamenti personalizzati per recupero post-infortunio, post-chirurgico, e gestione del dolore cronico. Prenota una visita oggi stesso!" />
        <meta property="og:site_name" content="mcare" />
        <meta property="og:locale" content="it_IT" />
      </Helmet> */}

      <Hero handleClickForm={handleClickForm} />

      {/* SEZ. Università */}
      <div className='relative md:h-screen h-[1150px] overflow-hidden'>
        <img src={section2} alt="background section" className='h-full w-full object-cover bg-black opacity-60' />
        <div className='absolute inset-0 flex space-x-10'>
          
          <div className='flex flex-col h-full justify-center gap-16 w-full xl:w-2/3 px-10 lg:ml-32'>
            <div className='flex flex-col text-start gap-10'>
              <h2 className='text-white text-3xl md:text-4xl font-bold uppercase panoragraf-light' data-aos="fade-up" data-aos-duration="1000">Il recupero è scienza applicata</h2>
              <p className='text-white text-xl' data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">MCare nasce con un obiettivo preciso:  trasformare il recupero fisico in un percorso rapido, scientifico e multidisciplinare.</p>
            </div>
            <div className='flex flex-row gap-4 items-baseline flex-wrap' data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
              <p className='text-white text-xl text-start'>Un metodo scientifico costruito su: </p>
              <AnimatedTextWord texts={textsFirstSection} />
            </div>

            <div className='border-t border-white/50 w-full md:block hidden'/>

            {/* MOBILE: swiper */}
            <div className='md:hidden block'>
              <Swiper
                  slidesPerView={1}
                  spaceBetween={20}
                  autoplay={{
                      delay: 4000,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                  }}
                  modules={[Autoplay]}
                  className="w-full h-full">
                  {flags.map((flag, index) => (
                    <SwiperSlide key={index} className="overflow-hidden bg-[#65806E99] p-4 rounded-lg gap-6"
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.5rem' }}>
                      <img src={flag.img} alt={flag.title} className='w-16 h-16' />
                      <p className='text-white text-base font-semibold uppercase'>{flag.title}</p>
                      <p className='text-white text-base uppercase text-center'>{flag.subtitle}</p>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>

            <div className='flex flex-col md:flex-row items-center gap-4'>
              <img src={logoUniversita} alt="logo università di verona" className='w-20 h-20' data-aos="fade-in" data-aos-duration="1000"/>
              <p className='text-white text-xs tracking-normal md:text-base uppercase text-center md:text-start' data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">centro universitario affiliato all'università degli studi di verona</p>
            </div>
          </div>

          {/* DESKTOP: flags a destra con animazione */}
          {/* <div className="w-full xl:w-1/3 h-fit relative md:block hidden">
            {flags.map((flag, index) => (
              <div
                key={index}
                className="absolute right-0 w-full"
                style={{ top: `${(index + 1.5) * 8}rem` }}
                onMouseLeave={closeFlag}>
                <div className={`flex items-center bg-[#65806E99] w-full rounded-l-xl p-3 gap-3 transition-transform duration-500  
                    ${
                      activeFlag === index
                        ? "translate-x-0"
                        : "translate-x-[calc(100%-85px)]"
                    }
                  `}>
                  <img
                    src={flag.img}
                    alt={flag.title}
                    className="w-16 h-16 shrink-0 cursor-pointer"
                    onMouseEnter={() => openFlag(index)}
                    onClick={() => openFlag(index)}
                  />

                  <div className="text-white flex flex-row flex-wrap">
                    <p className="font-semibold text-start w-full">
                      {flag.title}
                    </p>
                    <p className="text-start w-full">{flag.subtitle}</p>
                  </div>
                </div>
              </div>
            ))}
          </div> */}

          <div className='flex-col justify-center gap-8 md:flex hidden'>
            {flags.map((flag, index) => (
              <div key={index} className="flex flex-row items-center gap-4 bg-[#65806E99] w-full rounded-l-xl p-3 text-white">
                <img src={flag.img} alt={flag.title} className='w-16 shrink-0'/>
                <div>
                  <p className="font-semibold text-start w-full">{flag.title}</p>
                  <p className="text-start w-full">{flag.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <GridBox handleClickForm={handleClickForm}/>

      {/* SEZ TRATTAMENTI MOBILE */}
      <div className="grid grid-cols-4 gap-2 pb-20 bg-black pt-16" data-aos="fade-up" data-aos-duration="1000">
        <div className="col-span-4 text-center">
          <p className='font-semibold text-4xl my-10 panoragraf-light text-mcare'>Trattamenti personalizzati</p>
        </div>
        <div className="col-span-4 flex justify-center items-center">
          <p className="text-white text-center text text-xl px-5 xl:px-60"><strong>MCARE</strong> non è solo un centro di riabilitazione, ma un partner affidabile nel percorso di recupero e <em className='font-bold'>miglioramento della qualità di vita.</em></p>
        </div>
      </div>
      {/* prima parte sezioni trattamenti */}
      <div className="grid grid-cols-6 gap-10 px-0 md:px-40 lg:px-[30%] xl:px-0 2xl:px-32 xl:hidden">
        {/* prima parte */}
        <div className="col-span-6 xl:col-span-2 relative overflow-hidden">
          <figure ref={refTesta} className="effect-apollo">
            <img src={imageTesta} className='w-full' alt="Testa/Collo" />
            <div className='bg-black/60 absolute top-0 right-0 z-0 h-full w-full'/>
            <figcaption onClick={() => goToPage('/testa-collo/')}>
              <h2 className='text-start font-bold uppercase'>Testa/Collo</h2>
              <p>Dolore cervicale, ernie cervicali, post intervento chirurgico, terapia post colpo di frusta, cefalee, quadri vertiginosi, problematiche temporo-mandibolari (ATM).</p>
              <button onClick={handleClickForm}></button>
            </figcaption>
          </figure>
        </div>
        <div ref={refSpalle} className="col-span-6 xl:col-span-2 relative overflow-hidden">
          <figure className="effect-apollo">
            <img src={imageSpalle} className='w-full' alt="img22" />
            <div className='bg-black/60 absolute top-0 right-0 z-0 h-full w-full'/>
            <figcaption onClick={() => goToPage('/spalla/')}>
              <h2 className='text-start font-bold uppercase'>Spalle</h2>
              <p>Tendinopatie, lussazioni, lesioni della cuffia dei rotatori, spalla congelata.</p>
              <button onClick={handleClickForm}></button>
            </figcaption>
          </figure>
        </div>
        <div ref={refGinocchio} className="col-span-6 xl:col-span-2 relative overflow-hidden">
          <figure className="effect-apollo">
            <img src={imageGinocchio} className='w-full' alt="img22" />
            <div className='bg-black/60 absolute top-0 right-0 z-0 h-full w-full'/>
            <figcaption onClick={() => goToPage('/ginocchio/')}>
              <h2 className='text-start font-bold uppercase'>Ginocchio</h2>
              <p>Lesioni legamentose, sindrome femoro-rotulea, tendinopatie.</p>
              <button onClick={handleClickForm}></button>
            </figcaption>
          </figure>
        </div>
      </div>
      <div className="col-span-3 relative flex justify-center overflow-hidden my-16 xl:hidden">
        <p className="text-white text-center text text-xl px-5 lg:px-52">
          <strong>MCARE</strong> rappresenta la soluzione nella riabilitazione fisica e sportiva. Situato alle porte di Verona, il nostro centro si distingue per l'uso di tecniche all'avanguardia e un team di specialisti dedicati, che operano in un ambiente moderno e confortevole.</p>
      </div>
      {/* seconda parte sezioni trattamenti*/}
      <div className="grid grid-cols-6 gap-10 pb-10 px-0 md:px-40 lg:px-[30%] xl:px-0 2xl:px-32 xl:hidden">
        <div ref={refAnca} className="col-span-6 xl:col-span-2 relative overflow-hidden">
          <figure className="effect-apollo">
            <img src={imageAnca} className='w-full' alt="img22" />
            <div className='bg-black/60 absolute top-0 right-0 z-0 h-full w-full'/>
            <figcaption onClick={() => goToPage('/anca-bacino/')}>
              <h2 className='text-start font-bold uppercase'>Anca/Bacino</h2>
              <p>Impingement femoro-acetabolare, tendinopatie, fratture, protesi dell'anca.</p>
              <button onClick={handleClickForm}></button>
            </figcaption>
          </figure>
        </div>
        <div ref={refCaviglia} className="col-span-6 xl:col-span-2 relative overflow-hidden">
          <figure className="effect-apollo">
            <img src={imagePiede} className='w-full' alt="img22" />
            <div className='bg-black/60 absolute top-0 right-0 z-0 h-full w-full'/>
            <figcaption onClick={() => goToPage('/caviglia-piede/')}>
              <h2 className='text-start font-bold uppercase'>Caviglia e Piede</h2>
              <p>Distorsioni, fascite plantare, tendinopatie, lesioni osteocondrali.</p>
              <button onClick={handleClickForm}></button>
            </figcaption>
          </figure>
        </div>
        <div ref={refSchiena} className="col-span-6 xl:col-span-2 relative overflow-hidden">
          <figure className="effect-apollo">
            <img src={imageSchiena} className='w-full' alt="img22" />
            <div className='bg-black/60 absolute top-0 right-0 z-0 h-full w-full'/>
            <figcaption onClick={() => goToPage('/schiena/')}>
              <h2 className='text-start font-bold uppercase'>Schiena</h2>
              <p>Lombalgia, ernia del disco, stenosi, spondilolistesi.</p>
              <button onClick={handleClickForm}></button>
            </figcaption>
          </figure>
        </div>
      </div>

      {/* SEZ TRATTAMENTI DESKTOP */}
      <div className='hidden xl:block'>
        <HumanBody prenota={handleClickForm} />
      </div>

      {/* SEZ. TECNOLOGIE */}
      <Minimal 
      title="Tecnologie Sport-Oriented" 
      image={TecnologieImg} 
      alt
      imageMobileHidden={true}
      buttonText="scopri di più"
      sideSection="right"
      containerWidth="md:w-4/5 w-full"
      extraClass="space-y-6"
      content={
        <div className="text-xl" data-aos="fade-up" data-aos-duration="1000">
            <p className="text-balance lg:text-wrap">
                Presso il nostro centro di fisioterapia, abbracciamo l'innovazione
                utilizzando le più recenti tecnologie per garantire ai nostri
                pazienti esperienze di riabilitazione avanzate e personalizzate.
            </p>
        </div>
      }/>

      {/* SEZ. MCARE IN 3 PAROLE */}
      {/* <div className={`relative z-21 h-lvh overflow-hidden flex justify-center items-center lg:bg-mcare`}>
        <div className={`w-full h-full flex`}>
          <div className={`absolute lg:relative flex flex-col justify-center items-start text-left z-10 px-10 2xl:px-32 xl:w-3/5 w-full translate-y-16 lg:translate-y-0`}>
            <img src={logoShort} alt="Company Logo" className="pb-2 sm:mb-0 sm:me-10 w-1/4" />
            <hr className="border-b-3 border border-[#65806E] bg-[#65806E] w-20 mt-5 h-0.5" />
            <div className='text-xl text-white flex flex-col xl:flex-row justify-start mt-10 mb-5'>
              <p className='font-medium'>Le nostre parole chiave sono </p>
              <TextTransition className='uppercase py-5 xl:py-0 xl:ps-2 lg:text-4xl text-3xl xl:-mt-3' springConfig={presets.wobbly}>{TEXTS[index % TEXTS.length]}</TextTransition>
            </div>
            <div className={`text-md xl:text-lg text-md mt-4 mb-10 text-slate-50`} data-aos="fade-up" data-aos-duration="1000">
              MCARE nasce dalla passione e dall’impegno dei nostri fisioterapisti, che vantano un’esperienza pluriennale nella gestione di pazienti con disturbi muscolo-scheletrici. La filosofia di MCARE è mettere <em>la persona al centro</em> del percorso terapeutico:<br /> per questo, ogni piano di cura è personalizzato in base alle esigenze del singolo paziente.
            </div>
            <button onClick={handleClickForm} rel='noopener noreferrer' className={`px-8 py-2 progress-button-mcare `}>Scopri di più</button>
          </div>
          <div className={`relative overflow-hidden flex justify-start items-center opacity-60 xl:w-2/5 w-full`}>
            <ScrollParallax enableOnTouchDevice={true} lerpEase="0.05" className="absolute inset-0">
              <img src={big1} className="h-full w-full object-right object-cover pe-1 opacity-60 lg:opacity-90" alt="background" style={{ transform: 'scale(1.2)' }} />
            </ScrollParallax>
          </div>
        </div>
      </div> */}

      {/* SEZ PROFESSIONISTI */}
      <Minimal 
      title="I nostri professionisti" 
      image={professionisti} 
      alt
      imageMobileHidden={false}
      buttonText="scopri di più"
      sideSection="right"
      containerWidth="md:w-4/5 w-full"
      extraClass="space-y-6"
      content={
        <div className="text-xl text-white" data-aos="fade-up" data-aos-duration="1000">
            <p className="text-balance lg:text-wrap">
            Scopri il nostro team di professionisti pronto a seguirti nel tuo percorso di riabilitazione.<br/>
            Un team multidisciplinare composto da fisioterapisti specializzati in:
            </p>
            <ul className='mt-4 list-disc list-inside'>
              <li>Medicina dello sport</li>
              <li>Ortopedia</li>
              <li>Preparazione Atletica</li>
              <li>Mental Coaching</li>
            </ul>
        </div>
      }/>

      {/* PSICOLOGIA DELLO SPORT */}
      <Minimal 
      title="Psicologia dello sport" 
      image={player} 
      alt
      imageMobileHidden={true}
      buttonText="scopri di più"
      sideSection="left"
      containerWidth="md:w-4/5 w-full"
      extraClass="space-y-6"
      content={
        <div className="text-xl" data-aos="fade-up" data-aos-duration="1000">
            <p className="text-balance lg:text-wrap">
              Supporto psicologico personalizzato per affrontare sfide emotive, motivazionali e mentali durante la carriera sportiva.
            </p>
            <ul className="mt-4 list-disc list-inside">
              <li>Colloqui individuali</li>
              <li>Mental Training post infortunio</li>
              <li>Assessment psicologico</li>
              <li>Tecniche di rilassamento e gestione dello stress</li>
            </ul>
        </div>
      }/>

      {/* SEDI */}
      <Minimal 
      title="Dove ci trovi" 
      image={mCareSede}
      alt
      imageMobileHidden={false}
      sideSection={false}
      containerWidth="w-full"
      extraClass="space-y-20"
      content={
        <div className='grid md:grid-cols-2 grid-cols-1 place-content-center md:gap-24 gap-16 mx-4 md:mx-0'>
          <div className='flex flex-col items-center gap-10'>
              <FaLocationDot size={40} color="white" />
              <Link to="https://maps.app.goo.gl/wqGkMEmPocxQ7DjXA" target="_blank" className='text-white underline-animate text-xl skip-ink-auto'>Via Enrico Fermi 13/A, 37135, Verona</Link>
          </div>
          <div className='flex flex-col items-center gap-1'>
            <div className='flex flex-col items-center gap-10'>
              <FaLocationDot size={40} color="white" />
              <Link to="https://maps.app.goo.gl/xyPVjWf95XXx7KPA8" target="_blank" className='text-white underline-animate text-xl skip-ink-auto'>Via Toscana 13, 37060, Sona (VR)</Link>
            </div>
            <p className='uppercase text-sm text-white italic bg-mcare py-1 px-2 rounded-sm mt-2'>Prossima apertura Agosto 2026</p>
          </div>
        </div>
      }/>

      {/* sez. I nostri professionisti */}
      {/* <div className="grid grid-cols-4 gap-2 py-10 bg-[#252F29]">
        <div className="col-span-4 text-center">
          <p className='text-slate-50 font-semibold text-4xl my-10 panoragraf-light'>I nostri professionisti</p>
        </div>
      </div>
      <div className="block px-0 sm:px-10 xl:px-40 pb-20 bg-[#252F29]">
        <PeopleSlider />
      </div> */}

      {/* sez. contatti */}
      <div className="grid grid-cols-4 gap-0" id='formContatti'>
        <div className="col-span-4 flex justify-center items-center py-32 bg-black">
          <div className="w-full absolute z-0" style={{ "height": "120%" }}></div>
          <div className='w-full lg:w-2/6 z-40 px-5'>
            <p className='text-center text-4xl font-semibold mb-6 text-mcare panoragraf-light'>Prenota una visita</p>
            <ContactForm
              LandingName='mcare'
              Name={true}
              NameClass='text-slate-50'
              NameText='Nome e Cognome:'
              NameRequired={true}
              Tel={true}
              TelClass='text-slate-50'
              TelText='Telefono:'
              TelRequired={true}
              Email={true}
              EmailClass='text-slate-50'
              EmailText='Email:'
              EmailRequired={true}
              ConsensoDati={true}
              ConsensoDatiRequired={true}
              ConsensoDatiText="Consenso dati"
              ConsensoDatiID={1}
              ConsensoDatiClass='text-slate-50'
              successText='Messaggio inviato con successo!'
              successLink='/'
              errorText='Si è verificato un errore, Riprova!'
              SendText='Invia'
              SendClass='progress-button-mcare w-full '
            />
          </div>
        </div>
      </div>
      <ContactModal isContactModal={contactModal} closeModal={closeContactModal} />
    </>
  )
}

export default HomePage;
